module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_uk_ukrainian-af1d11dab17044ee2036a635e89196cd.svg";